import { Col, Modal, Row } from "antd";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { configMenuSelector } from "../../../../services/selector/index.";
import BaseButton from "../../Button/BaseButton";
import TranslateText from "../../TranslateText";
import "../../../../assets/style/modalStyle/addAccount.scss";
import LabelInput from "../../LabelInput";
import InputText from "../../Input/InputText";
import { useState } from "react";
import SelectValue from "../../Selector/SelectValue";

import {
  editTabMenu,
  getAllDisplay,
  setOpenModalEditTabMenu,
} from "../../../../services/slice/ConfigMenuSlice";
import UploadIcon from "../../Button/UploadIcon";
import {
  selectRouterAdmin,
  selectRouterClient,
} from "../../../../utils/ValueSelect";
import { validateUrl } from "../../../../utils/functionCommon";

const ModalEditTabMenu = ({ type }) => {
  const configMenuState = useSelector(configMenuSelector);
  const dispatch = useDispatch();
  const [icon, setIcon] = useState(null);
  const { dataEdit } = configMenuState;
  const language = localStorage.getItem("language");
  const { dataDisplay } = configMenuState;
  const valueSelect = useMemo(() => {
    const result = [];
    if (dataDisplay) {
      dataDisplay.map((item) => {
        result.push({
          value: item.router,
          label:
            language === "Tiếng Việt" ? item.componentVn : item.componentEn,
        });
      });
    }
    return result;
  }, [dataDisplay, language]);
  const [dataPost, setDataPost] = useState({
    file: dataEdit.icon,
    id: dataEdit.id,
    nameVn: dataEdit.nameVn,
    nameEn: dataEdit.nameEn,
    router: dataEdit.router,
    url: dataEdit.url,
    typeUrl: dataEdit.typeUrl,
    type: type,
  });
  const handleCancel = () => {
    dispatch(setOpenModalEditTabMenu({ isOpen: false, data: "" }));
  };
  const [msgErr, setMsgErr] = useState("");
  const handleSave = () => {
    const allowedFormats = ["image/svg+xml"];
    if (
      !dataPost.file ||
      !dataPost.nameVn ||
      !dataPost.nameEn ||
      !dataPost.router ||
      !dataPost.typeUrl ||
      (dataPost.typeUrl !== "local" && !dataPost.url)
    ) {
      setMsgErr("Vui lòng nhập đầy đủ thông tin");
      return;
    }
    if (dataPost.typeUrl !== "local" && !validateUrl(dataPost.url)) {
      setMsgErr("Đường dẫn không đúng định dạng");
      return;
    }
    if (icon && !allowedFormats.includes(icon.type)) {
      setMsgErr("Icon không đúng định dạng");
      return;
    }
    const formPost = new FormData();
    if (icon) {
      formPost.append("file", icon);
    }
    formPost.append("id", dataPost.id);
    formPost.append("type", dataPost.type);
    formPost.append("nameVn", dataPost.nameVn);
    formPost.append("nameEn", dataPost.nameEn);
    formPost.append("router", dataPost.router);
    formPost.append("typeUrl", dataPost.typeUrl);
    formPost.append("url", dataPost.url);
    dispatch(editTabMenu(formPost));
    setMsgErr("");
  };
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text={"Chỉnh sửa Tab"} />}
        centered
        open={configMenuState.isOpenModalEditTab}
        className="warrperModalAddAcc"
        width={645}
        footer={[
          <div className="evenSpace">
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="btnCancel"
              width={155}
              handleClick={handleCancel}
            />
            <BaseButton
              isEnter={true}
              width={155}
              content={"Lưu"}
              typeBtn="btnOrange"
              handleClick={handleSave}
            />
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Row align={"middle"} style={{ marginBottom: "1.5rem" }}>
          <Col span={7}>
            <LabelInput text={"Tên tiếng Việt của Tab"} />
          </Col>
          <Col span={17}>
            <InputText
              focus
              text={dataPost.nameVn}
              setText={(value) => setDataPost({ ...dataPost, nameVn: value })}
              typeInput={`${
                (!dataPost.nameVn && msgErr) ||
                msgErr === "Duplicate menu tab name"
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
              placeholder={"Nhập tên tab"}
            />
          </Col>
        </Row>
        <Row align={"middle"} style={{ marginBottom: "1.5rem" }}>
          <Col span={7}>
            <LabelInput text={"Tên tiếng Anh của Tab"} />
          </Col>
          <Col span={17}>
            <InputText
              text={dataPost.nameEn}
              setText={(value) => setDataPost({ ...dataPost, nameEn: value })}
              typeInput={`${
                !dataPost.nameEn && msgErr
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
              placeholder={"Nhập tên Tiếng Anh của tab"}
            />
          </Col>
        </Row>

        <Row align={"middle"} style={{ marginBottom: "1.5rem" }}>
          <Col span={7}>
            <LabelInput text={"Giao diện hiển thị"} />
          </Col>
          <Col
            span={17}
            style={
              !dataPost.typeUrl && msgErr
                ? {
                    border: "1px solid red",
                    width: "100%",
                    textAlign: "left",
                  }
                : { width: "100%", textAlign: "left" }
            }
          >
            <SelectValue
              width={"100%"}
              style={{ textAlign: "left" }}
              handleChange={(value) => {
                setDataPost({
                  ...dataPost,
                  typeUrl: value,
                });
              }}
              optionsValue={valueSelect ? valueSelect : []}
              type={"base"}
              defaultValue={
                valueSelect.length
                  ? valueSelect.find((item) => item.value === dataPost.typeUrl)
                      ?.label
                  : ""
              }
            />
          </Col>
        </Row>

        <Row
          align={"middle"}
          style={{ position: "relative", marginBottom: "1.5rem" }}
        >
          <Col span={7}>
            <LabelInput text={"Điều hướng đến"} />
          </Col>
          <Col
            span={17}
            style={
              !dataPost.router && msgErr
                ? {
                    border: "1px solid red",
                    width: "100%",
                    textAlign: "left",
                  }
                : { width: "100%", textAlign: "left" }
            }
          >
            <SelectValue
              handleChange={(value) => {
                setDataPost({
                  ...dataPost,
                  router: value,
                });
              }}
              optionsValue={type ? selectRouterAdmin : selectRouterClient}
              type={"base"}
              width={"100%"}
              defaultValue={
                type
                  ? selectRouterAdmin.find(
                      (item) => item.value === dataPost.router
                    ).label
                  : selectRouterClient.find(
                      (item) => item.value === dataPost.router
                    ).label
              }
            />
          </Col>
        </Row>
        {dataPost.typeUrl !== "local" ? (
          <Row
            align={"middle"}
            style={{ position: "relative", marginBottom: "1.5rem" }}
          >
            <Col span={7}>
              <LabelInput text={"Nhập link"} />
            </Col>
            <Col
              span={17}
              style={
                (!dataPost.url && msgErr) ||
                msgErr === "Đường dẫn không đúng định dạng"
                  ? {
                      border: "1px solid red",
                      width: "100%",
                      textAlign: "left",
                    }
                  : { width: "100%", textAlign: "left" }
              }
            >
              <InputText
                text={dataPost.url}
                setText={(value) => setDataPost({ ...dataPost, url: value })}
                typeInput={"baseInput"}
                placeholder={"Nhập link"}
              />
            </Col>
          </Row>
        ) : null}

        <Row
          align={"middle"}
          style={{ position: "relative", marginBottom: "1.5rem" }}
        >
          <Col span={7}>
            <LabelInput text={"Chọn icon"} />
          </Col>
          <Col
            span={3}
            style={{ display: "flex", justifyContent: "start", width: "100%" }}
          >
            <UploadIcon
              width={"100%"}
              url={dataPost.file}
              setImage={(file) => setIcon(file)}
            />
          </Col>
          <Col span={7}>
            <span
              style={{
                fontStyle: "italic",
                fontSize: "1.4rem",
                color: "#4F4F4F",
              }}
            >
              (<TranslateText text={"file có định dạng .svg"} />)
            </span>
          </Col>
          <small className="msg" style={{ bottom: -30, right: 0 }}>
            {msgErr}
          </small>
        </Row>
      </Modal>
    </>
  );
};

export default ModalEditTabMenu;
